import { AnimationBaseController } from "@denishussar/html5-game-engine";
import { Inject } from "@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "@denishussar/html5-game-engine";
import { GameLogic } from "../Logic/PrintCardLogic";

export interface IButtonControllerOptions {
  onClick: () => void;
}

export class CardColorController extends AnimationBaseController {
  $model: any;

  public constructor(
    @Inject private _options: IButtonControllerOptions,
    @Inject private _gameLogic: GameLogic
  ) {
    super("CardColorController");
  }

  protected getConfiguration(): IAnimationControllerConfiguration {
    return {
      onPointerDown: (e) => {
        this._gameLogic.selectColor(this.$model);
      },
      onPointerOver: () => {},
    };
  }

  protected onInitialize(): void {
   
  }

  protected onAnimationEvent(name: string, ...args): void {}
}
